import axios from "../../../../../services/api";
import Axios, { AxiosResponse } from "axios";
import { getEnv } from "../../../../../api";
import { IArquivosAnexosService } from "./interfaces";

export const ArquivosAnexosService: IArquivosAnexosService = {
  findAll: async (params, body = {}) => {
    try {
      // @ts-ignore
      const response: AxiosResponse = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/arquivo/anexo/consultar`,
        body,
        {
          params,
        }
      );

      return response.data;
    } catch (error: any) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada", error.message);
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  getTemas: async (idTemaMacro: string) => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/sas/atendimentos/temas/${idTemaMacro}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getOptions: async () => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/arquivo/anexo/opcoes`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  create: async (body) => {
    try {
      // @ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/arquivo/anexo`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  read: async (idAnexo) => {
    try {
      if (!idAnexo) return;

      // @ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/arquivo/anexo?idAnexo=${idAnexo}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  update: async (body) => {
    try {
      // @ts-ignore
      const response = await axios.put(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/arquivo/anexo`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  delete: async (idAnexo) => {
    try {
      // @ts-ignore
      const response = await axios.delete(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/arquivo/anexo?idAnexo=${idAnexo}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  updateStatus: async ({ id, status }) => {
    try {
      // @ts-ignore
      const response = await axios.put(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/arquivo/anexo/alterar-status?idAnexo=${id}&status=${status}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
};
